import ImageAiForm from '@solundo/image-ai/js/ImageAiForm';

let initialized = false;
let init = () => {
	if (!initialized) {
		initialized = true;
		new ImageAiForm();
	}
};

// bij first page load staat het formulier er al; wordt het pas later via ajax geplaatst, dan triggert de configurator het event
jQuery(() => jQuery('#image-ai-form').length && init());
jQuery(document).on('image-ai:init', init);
